import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { uploadFile } from "shared-utility/store/utils/fileHelper";
import {
  defaultReturn,
  makePayload,
  makeWritePayload,
  generateDefaultActions,
  requestSaga,
  callbackSaga,
  subKeySaga,
  fillDictionary,
  handleCallback,
  multipleObjectReturn
} from "shared-utility/store/utils/helpers";
import { authorizedRequest } from "utils/api";
import { generate } from "shortid";

import { ToastSuccess, ToastError, ToastInfo } from "../../Global/Toasts/Toasty";

// ACTIONS
const TEST_HARNESS_RECOURSE_SCHEDULE = generateDefaultActions("TEST_HARNESS_RECOURSE_SCHEDULE");
export const recalculateRecourseSchedule = payload => makePayload(TEST_HARNESS_RECOURSE_SCHEDULE.value, payload);
function* recalculateRecourseScheduleSaga(payload) {
  const url = `/servermetrics/recourseMetricCalculation?loanId=${payload.loanId}`;
  yield requestSaga(TEST_HARNESS_RECOURSE_SCHEDULE, url, "GET");
}

// REDUCER
const initialState = {};

export function apiTestHarnessReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TEST_HARNESS_RECOURSE_SCHEDULE.success:
      ToastSuccess("Request sent");

      return defaultReturn(state);

    case TEST_HARNESS_RECOURSE_SCHEDULE.failure:
      ToastError("Something went wrong");

      return defaultReturn(state);

    default:
      return state;
  }
}

// SAGA
export function* apiTestHarnessSaga() {
  yield takeLatest(TEST_HARNESS_RECOURSE_SCHEDULE.value, recalculateRecourseScheduleSaga);
}
